var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanceFloor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103.99999809265137,
    height: 475,
    viewBox: "0 0 103.99999809265137 475",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 1L15.5 1L15.5 2L15 2L15 202L15.8752 202C6.68267 211.224 0.999998 223.948 0.999998 238C0.999998 251.6 6.32333 263.957 15 273.1L15 473L15.5 473L15.5 474L87 474L87 275.095C96.8515 265.796 103 252.616 103 238C103 223.384 96.8515 210.204 87 200.905L87 2L86.5 2L86.5 1ZM85 3L17 3L17 200.905C26.1333 192.285 38.4495 187 52 187C64.585 187 76.1054 191.558 85 199.114L85 3ZM85.2419 274L85 274L85 274.222C76.2921 282.16 64.7113 287 52 287C24.938 287 3 265.062 3 238C3 210.938 24.938 189 52 189C64.7113 189 76.2921 193.84 85 201.778L85 202L85.2419 202C94.932 210.952 101 223.767 101 238C101 252.233 94.932 265.048 85.2419 274ZM85 276.886L85 472L17 472L17 275.095C26.1333 283.715 38.4495 289 52 289C64.585 289 76.1054 284.442 85 276.886Z",
    stroke: "rgba(0, 0, 0, 1)",
    strokeWidth: 2,
    fillRule: "evenodd",
    fill: "#FAEFE9",
    fillOpacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanceFloor);
export default __webpack_public_path__ + "static/media/dance_floor.421d08c995aedaf1fbf74527210f4165.svg";
export { ForwardRef as ReactComponent };